var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalculator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 41,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  y: 0.5,
  fill: "#E6EFE3",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#56893E",
  d: "M27 11.5H13c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2m-5.44 3.53c.29-.29.77-.29 1.06 0l.88.88.88-.88c.29-.29.77-.29 1.06 0s.29.77 0 1.06l-.88.88.88.88c.29.29.29.77 0 1.06s-.77.29-1.06 0l-.88-.87-.88.88c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l.88-.88-.88-.88c-.3-.3-.3-.78 0-1.07M15 16.22h3.5c.41 0 .75.34.75.75s-.34.75-.75.75H15c-.41 0-.75-.34-.75-.75s.34-.75.75-.75m3.75 8.28H17.5v1.25c0 .41-.34.75-.75.75s-.75-.34-.75-.75V24.5h-1.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H16v-1.25c0-.41.34-.75.75-.75s.75.34.75.75V23h1.25c.41 0 .75.34.75.75s-.34.75-.75.75m6.5 1.25h-3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75m0-2.5h-3.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75"
})));
export default SvgCalculator;